import stylex from '@stylexjs/stylex';
import { colors } from '@shared/tokens/colors.stylex';

export const scrollbarStyles = stylex.create({
  host: {
    position: 'relative',
    flex: 1,
    minHeight: 0,
    display: 'flex',
    flexDirection: 'column',
  },
  scroll: {
    flex: 1,
    minHeight: 0,
    overflowY: 'auto',
    overflowX: 'hidden',
    boxSizing: 'border-box',
    width: '100%',
    margin: 0,
    padding: '4px',
    listStyle: 'none',
    scrollbarWidth: 'none',
    msOverflowStyle: 'none',
    '::-webkit-scrollbar': {
      width: 0,
      height: 0,
    },
  },
  track: {
    position: 'absolute',
    top: 0,
    right: '4px',
    width: '4px',
    height: '100%',
    borderRadius: '4px',
    backgroundColor: colors.ghostBackground,
  },
  thumb: {
    position: 'absolute',
    left: 0,
    width: '4px',
    borderRadius: '4px',
    backgroundColor: colors.accentBackground,
  },
});
